<div class="flex flex-col items-center h-full">
    <div class="flex items-center gap-2">
        <div class="text-xl font-semibold">Overpayments</div>
        <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
           pTooltip="Customer overpayments that need to be refunded"
           tooltipPosition="top"></fa-icon>
    </div>
    
    <div *ngIf="isLoading()" class="flex justify-center items-center gap-3" style="height: 200px;">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <span class="text-lg">Loading...</span>
    </div>

    <div *ngIf="!isLoading()" class="flex flex-col items-center gap-4 py-4">
        <div class="text-center">
            <div class="text-2xl font-light">Total: {{totalOverpayments() | currency:'USD':'symbol':'1.0-0'}}</div>
            <div class="text-sm text-gray-600">Count: {{countOverpayments()}}</div>
        </div>
        <div *ngIf="authService.hasAnyRole(['ops', 'it'])">
            <p-button label="View Details" (click)="showDetailsDialog()" styleClass="btn btn-primary"></p-button>
        </div>
    </div>
</div>

<p-dialog header="Overpayments Details" [(visible)]="detailsDialogVisible"
    [breakpoints]="{'960px': '98vw', '1200px': '95vw'}" [style]="{'width': '98vw', 'max-width': 'none'}" [modal]="true"
    [dismissableMask]="true" appendTo="body">

    @if (dialogLoading()) {
    <div class="flex justify-center items-center gap-3" style="height: 200px;">
        <p-progressSpinner [style]="{'width': '50px', 'height': '50px'}" strokeWidth="4" fill="transparent"
            animationDuration=".5s"></p-progressSpinner>
        <span class="text-lg">Loading...</span>
    </div>
    } @else {
    <p-table #overPaymentsTable [value]="overpayments()" [columns]="tableColumns"
        styleClass="p-datatable-gridlines responsive-table" [tableStyle]="{'width': '100%'}"
        exportFilename="Overpayments Details"
        [globalFilterFields]="['tripID', 'consultantName', 'customerGroup', 'leaderName', 'destination', 'tripDate']"
        [scrollable]="true" scrollHeight="70vh" [resizableColumns]="true" columnResizeMode="expand">

        <ng-template pTemplate="caption">
            <app-table-caption [table]="overPaymentsTable"></app-table-caption>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <app-table-headers [columns]="tableColumns"></app-table-headers>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-overpayment>
            <tr>
                <app-table-columns [columns]="tableColumns" [data]="overpayment"></app-table-columns>
            </tr>
        </ng-template>
    </p-table>
    }

</p-dialog>